<template>
  <div class="reward-result">
    <div v-if="bindAward">
      <div class="result-item" v-if="bindAward.accountUserName">
        <div class="result-label">
          <span>姓名 </span>
        </div>
        <div class="result-value">
          <span>{{ bindAward.accountUserName }}</span>
        </div>
      </div>
      <div class="result-item" v-if="bindAward.accountUserPhone">
        <div class="result-label">
          <span>手机号 </span>
        </div>
        <div class="result-value">
          <span>{{ bindAward.accountUserPhone }}</span>
        </div>
      </div>
      <div class="result-item" v-if="isNeedExpress && bindAward.accountUserExtraInfo">
        <div class="result-label">
          <span>详细地址 </span>
        </div>
        <div class="result-value">
          <span>{{ bindAward.accountUserExtraInfo }}</span>
        </div>
      </div>
      <div class="result-item" v-else-if="bindAward.accountUserExtraInfo">
        <div class="result-label">
          <span v-if="isCoupon">优惠券兑换码 </span>
          <span v-else>附加信息 </span>
        </div>
        <div class="result-value">
          <span v-if="showAwardInfo">{{ bindAward.accountUserExtraInfo }}</span>
          <span v-else>***</span>
        </div>
      </div>
      <div v-if="isCoupon" class="text-center">
        <div>
          <span>可通过屏幕截图保存二维码</span>
        </div>
        <div class="mt-2">
          <coupon-qrcode />
        </div>
      </div>
    </div>
    <div class="mt-3 order-no" v-if="isNeedExpress">
      <div class="result-item">
        <div class="result-label">
          <span>快递单号 </span>
        </div>
        <div class="result-value" id="receiveOrderNo">
          <span v-if="!expressNo">等待发布者更新</span>
          <span v-else>{{ expressNo }}</span>
          <el-button v-if="expressNo" type="text" @click="onCopyOrderNo">复制</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AnswerStatus, copyText } from 'dygc'
import { Message } from 'dygc-ui'
import CouponQrcode from '@/components/reward/CouponQrcode.vue'

export default {
  name: 'RewardResult',
  components: { CouponQrcode },
  computed: {
    // receiveInfo() {
    //   return this.$bus.receiveInfo
    // },
    expressNo(){
      return this.bindAward.businessExtraInfo
    },
    bindAward() {
      return this.$bus.currentAwardData?.bindAward || {}
    },
    isNeedExpress() {
      return this.bindAward?.lotteryCategory === 1
    },
    isCoupon() {
      return this.bindAward?.lotteryCategory === 3
    },
    showAwardInfo() {
      if (this.$bus.survey.otherSetting.enableNetManualAudit) {
        return this.$bus.currentAnswerData.status === AnswerStatus.PASS
      }
      return true
    }
  },
  methods: {
    onCopyOrderNo() {
      copyText('#receiveOrderNo', this.bindAward.expressNo).then(() => {
        Message({
          type: 'success',
          message: '复制成功'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/mixin.scss';

.reward-result {
  @include useLabelItem('.result');

  .order-no {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding-top: 12px;
  }

  .result-label {
    margin-right: 16px;
  }
}
</style>
